import { Http } from '@angular/http';
import { HttpClient } from '@angular/common/http';
import { of } from 'rxjs';
import { environment } from './../../../../environments/environment';
import { UtilsService } from './../../../_services/utils.service';
import * as i0 from "@angular/core";
import * as i1 from "@angular/http";
import * as i2 from "@angular/common/http";
import * as i3 from "../../../_services/utils.service";
var PlayersService = /** @class */ (function () {
    function PlayersService(_http, http, _utilsService) {
        this._http = _http;
        this.http = http;
        this._utilsService = _utilsService;
    }
    PlayersService.prototype.getTeamPlayers = function (playerAPIUrl) {
        return this._utilsService.getRequest(playerAPIUrl);
    };
    PlayersService.prototype.getTeamList = function (teamAPIUrl) {
        return this._utilsService.getRequest(teamAPIUrl);
    };
    PlayersService.prototype.rosterPosition = function (teamAPIUrl) {
        return this._utilsService.getRequest(teamAPIUrl);
    };
    PlayersService.prototype.leaguePositionSettings = function (teamAPIUrl) {
        return this._utilsService.getRequest(teamAPIUrl);
    };
    PlayersService.prototype.defaultRanking = function (league_id, league_member_id) {
        var scorePost = { 'league_id': league_id, 'league_mem_id': league_member_id };
        return this._utilsService.postRequest("" + environment.phpApiUrl + '/league/removeRankings', scorePost, null, 'content-type-json');
    };
    PlayersService.prototype.handleErrorPost = function (operation, result) {
        if (operation === void 0) { operation = 'operation'; }
        return function (error) {
            // TODO: send the error to remote logging infrastructure
            console.error(error); // log to console instead
            // TODO: better job of transforming error for user consumption
            console.log(operation + " failed: " + error.message);
            // Let the app keep running by returning an empty result.
            return of(result);
        };
    };
    PlayersService.ngInjectableDef = i0.defineInjectable({ factory: function PlayersService_Factory() { return new PlayersService(i0.inject(i1.Http), i0.inject(i2.HttpClient), i0.inject(i3.UtilsService)); }, token: PlayersService, providedIn: "root" });
    return PlayersService;
}());
export { PlayersService };
